// src/EnhancedComponents/EContainer.js
import React, { lazy } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import Layout from "./Layout";
import Login from "./Login";
import { isAuthenticated } from "./auth";

// Pages are code-split so the login screen doesn't download the DataGrid.
const Dashboard = lazy(() => import("./Dashboard"));
const Users = lazy(() => import("./Users"));
const Events = lazy(() => import("./Events"));

function RequireAuth({ children }) {
  const location = useLocation();
  return isAuthenticated() ? (
    children
  ) : (
    <Navigate to="/login" replace state={{ from: location }} />
  );
}

function PublicOnly({ children }) {
  return isAuthenticated() ? <Navigate to="/" replace /> : children;
}

export default function EContainer() {
  return (
    <Routes>
      <Route
        path="/login"
        element={
          <PublicOnly>
            <Login />
          </PublicOnly>
        }
      />
      <Route
        element={
          <RequireAuth>
            <Layout />
          </RequireAuth>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="users" element={<Users />} />
        <Route path="events" element={<Events />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
